module.exports = __webpack_public_path__ + "img/teams_check.0ea576d5.png";